import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import { initNativePush } from "@/lib/nativePush";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Builder from "@/pages/Builder";
import AIGenerator from "@/pages/AIGenerator";
import Clone from "@/pages/Clone";
import Pro from "@/pages/Pro";
import ProSuccess from "@/pages/ProSuccess";
import Broker from "@/pages/Broker";
import Deployments from "@/pages/Deployments";
import { DeploymentDetail } from "@/components/Deployments";
import Journal from "@/pages/Journal";
import Gallery from "@/pages/Gallery";
import PublicStrategy from "@/pages/PublicStrategy";
import NotificationSettings from "@/pages/NotificationSettings";
import Companion from "@/pages/Companion";
import Leaderboard from "@/pages/Leaderboard";
import ABTest from "@/pages/ABTest";
import Referrals from "@/pages/Referrals";
import { WakeWordController } from "@/components/WakeWord";

function AppRouter() {
  const location = useLocation();
  const navigate = useNavigate();
  // Bootstrap native push exactly once on native platforms
  useEffect(() => { initNativePush(navigate); }, [navigate]);
  // OAuth callback: hash contains session_id — handle FIRST (synchronous during render)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/builder" element={<ProtectedRoute><Builder /></ProtectedRoute>} />
      <Route path="/builder/:id" element={<ProtectedRoute><Builder /></ProtectedRoute>} />
      <Route path="/ai" element={<ProtectedRoute><AIGenerator /></ProtectedRoute>} />
      <Route path="/clone" element={<ProtectedRoute><Clone /></ProtectedRoute>} />
      <Route path="/pro" element={<ProtectedRoute><Pro /></ProtectedRoute>} />
      <Route path="/pro/success" element={<ProtectedRoute><ProSuccess /></ProtectedRoute>} />
      <Route path="/broker" element={<ProtectedRoute><Broker /></ProtectedRoute>} />
      <Route path="/deployments" element={<ProtectedRoute><Deployments /></ProtectedRoute>} />
      <Route path="/deployments/:id" element={<ProtectedRoute><DeploymentDetail /></ProtectedRoute>} />
      <Route path="/journal" element={<ProtectedRoute><Journal /></ProtectedRoute>} />
      <Route path="/gallery" element={<Gallery />} />
      <Route path="/s/:slug" element={<PublicStrategy />} />
      <Route path="/settings/notifications" element={<ProtectedRoute><NotificationSettings /></ProtectedRoute>} />
      <Route path="/companion" element={<ProtectedRoute><Companion /></ProtectedRoute>} />
      <Route path="/leaderboard" element={<Leaderboard />} />
      <Route path="/ab-test" element={<ProtectedRoute><ABTest /></ProtectedRoute>} />
      <Route path="/referrals" element={<ProtectedRoute><Referrals /></ProtectedRoute>} />
      </Routes>
      <WakeWordController/>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster theme="dark" position="bottom-right" richColors closeButton
            toastOptions={{
              style: {
                background: "#12141A",
                border: "1px solid rgba(255,255,255,0.1)",
                fontFamily: "'IBM Plex Sans', sans-serif",
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
